/**
 * /cobranca/* — router-shell do modulo Cobranca (Boleto via gateway).
 *
 * Sub-rotas:
 *   /cobranca/boletos (default)
 *   /cobranca/configuracao
 */
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import BoletosLista from "./Boletos/Lista";
import Configuracao from "./Configuracao";


export default function CobrancaShell() {
  return (
    <Routes>
      <Route index element={<Navigate to="boletos" replace />} />
      <Route path="boletos" element={<BoletosLista />} />
      <Route path="configuracao" element={<Configuracao />} />
      <Route path="*" element={<Navigate to="boletos" replace />} />
    </Routes>
  );
}
